/* eslint-disable jsx-a11y/label-has-associated-control */
import { ChangeEvent } from "react";

type VariableTypeDropdownFieldProps = {
	value: string;
	onChange: (event: ChangeEvent<HTMLSelectElement>) => void;
	disabled?: boolean;
};

export enum VARIABLE_TYPE {
	SET = "SET",
	MEASURED = "MEASURED",
}

const VariableTypeDropdownField = (props: VariableTypeDropdownFieldProps) => {
	const { value, onChange } = props;
	return (
		<div className="flex w-full flex-col space-y-2">
			<label className="lg:text-md font-semibold md:text-sm">Type</label>
			<select
				className="border-2 border-gray-300 px-2 py-2 outline-none focus:border-2 focus:border-gray-300 focus:outline-none focus:ring-0 sm:w-full"
				value={value}
				onChange={onChange}
				disabled={props.disabled}
			>
				<option value={VARIABLE_TYPE.MEASURED} className="py-3 text-lg">
					Monitored
				</option>
				<option value={VARIABLE_TYPE.SET} className="py-3 text-lg">
					Set
				</option>
			</select>
		</div>
	);
};

export default VariableTypeDropdownField;
